export const LocationIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 21C12 21 19 14.75 19 9.5C19 5.35786 15.866 2 12 2C8.13401 2 5 5.35786 5 9.5C5 14.75 12 21 12 21Z"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle
                cx="12"
                cy="9.5"
                r="2.5"
                stroke={activeColor}
                strokeWidth="2"
            />
        </svg>
    );
}